"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVESTOR_INVITATION_MAX_SHARES = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ETypePersonneJuridique_1 = require("../../enums/ClientSheet/ETypePersonneJuridique");
const Resource_1 = __importDefault(require("../Resource"));
exports.INVESTOR_INVITATION_MAX_SHARES = 10000000;
class InvestorInvitationCreateRequestResource extends Resource_1.default {
}
exports.default = InvestorInvitationCreateRequestResource;
__decorate([
    (0, class_validator_1.IsEnum)(ETypePersonneJuridique_1.ETypePersonneJuridique),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], InvestorInvitationCreateRequestResource.prototype, "personType", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], InvestorInvitationCreateRequestResource.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], InvestorInvitationCreateRequestResource.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], InvestorInvitationCreateRequestResource.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsPhoneNumber)("FR"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], InvestorInvitationCreateRequestResource.prototype, "mobilePhone", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], InvestorInvitationCreateRequestResource.prototype, "companyName", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(4),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], InvestorInvitationCreateRequestResource.prototype, "productSheetId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1, { context: [1] }),
    (0, class_validator_1.Max)(exports.INVESTOR_INVITATION_MAX_SHARES, { context: [exports.INVESTOR_INVITATION_MAX_SHARES] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], InvestorInvitationCreateRequestResource.prototype, "proposedShares", void 0);
